import React from 'react';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { ThemedButton } from 'core/controls';

const getDisclosures = disableTutorial => {
  if (disableTutorial) {
    return null;
  }

  return (
    <div className="instructions__disclosures">
      <span className="dagger instructions__dagger" />
      <div className="instructions__content">
        <p>
          <Translate value="instructions.disclosures" />
        </p>
        <p>
          <Translate value="instructions.disclosures.text" />
        </p>
      </div>
    </div>
  );
};

const Instructions = ({ disableTutorial, onClose }) => {
  return (
    <div
      id="instructions-content"
      className="stat-image-link"
      data-dtm="tutorial"
      onClick={onClose}>
      <div className="instructions">
        <div className="instructions__look-for-symbols">
          <SvgIcon
            name="mail-reply"
            className="instructions__icon instructions__arrow"
          />
          <p className="instructions__look-for-symbols__row">
            <Translate value="instructions.symbols" />
          </p>
        </div>

        <div className="instructions__feature-availability">
          <SvgIcon
            name="feature-availability"
            className="instructions__icon instructions__svg-icon--feature-availability"
          />

          <div className="instructions__content">
            <p>
              <Translate value="instructions.feature.availability" />
            </p>
            <p>
              <Translate value="instructions.feature.availability.text" />
            </p>
          </div>
        </div>

        <div className="instructions__more-info">
          <SvgIcon name="info-instructions" className="instructions__icon" />
          <div className="instructions__content">
            <p>
              <Translate value="instructions.more.info" />
            </p>
            <p>
              <Translate value="instructions.more.info.text" />
            </p>
          </div>
        </div>

        {getDisclosures(disableTutorial)}

        <div className="instructions__continue">
          <ThemedButton
            primary
            className="instructions__continue-button"
            theme={{
              buick: 'button--inverted',
              cadillac: 'button--inverted'
            }}>
            <Translate value="instructions.continue" />
          </ThemedButton>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
